import { v4 as uuidv4 } from 'uuid';
import { WsSelectObj } from 'wisestep-base';
export type candidateInteractionMessagingPipelines = {
  id: string;
  name: string;
  condition?: string | undefined;
  color?: string | undefined;
  nodes: nodes[];
  action?: action;
};
export type nodes = {
  id: string;
  name: string;
  condition?: string | undefined;
  color?: string | undefined;
  nodes: nodes[];
  action?: action;
};
export type action = {
  name?: string;
  type?: string;
};

export const buildNewItem = (name) => {
  return { id: uuidv4(), name: name, action: {}, nodes: [] };
};
export const AddActionButtonDropDown: WsSelectObj[] = [
  { label: 'Send Email', value: '{"name":"Send Email","type":"Email"}' },
  { label: 'Update Status - Reject', value: '{"name":"Update Status - Reject","type":"Status"}' },
];
export const idArrayGenerator = (data: candidateInteractionMessagingPipelines[]) => {
  const tempArray: string[] = [];
  data?.map((item) => tempArray.push(item.id));
  return [...tempArray];
};
